<template>
    <b-container fluid>
        <b-row>
        <b-col lg="12" sm="12">
            <b-row>
                <b-col  v-if="loading" lg="12" sm="12" class="form-for-textarea">
                    <h4 class="text-center">{{ $t('externalUser.loading') }} .....</h4>
                </b-col>
                <b-col v-else lg="12" sm="12" class="form-for-textarea" style="border:1px solid gray">
                    <b-row class="row mt-4">
                        <b-col>
                        <list-report-head :hideReport="true" :base-url="awarenessEventServiceBaseUrl" uri="/configuration/report-heading/detail" :org-id="3">
                        </list-report-head>
                        </b-col>
                    </b-row>
                    <div class="row mt-4">
                        <div class="col-md-8">
                            <p class="badge badge-default bg-gray p-2 m-0" style="font-size:16px;color:black;font-weight:bold">{{ $t('delivery_management.distribution_receipt') }}</p>
                        </div>
                        <div class="col-md-4 text-dark">
                            <table>
                                <tr>
                                    <td>{{ $t('delivery_management.receipt_no') }}</td>
                                    <td>: {{ $n(formData.receipt_no, { useGrouping: false }) }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('delivery_management.distributed_date') }}</td>
                                    <td>: {{ formData.distributed_date | dateFormat }}</td>
                                </tr>
                            </table>
                        </div>
                    </div><hr>
                    <div class="row mt-5">
                        <div class="col-md-12 text-dark">
                            <table>
                                <tr>
                                    <td>{{ $t('delivery_management.total_assistive') }}</td>
                                    <td>: {{ $n(formData.total_devices, { useGrouping: false }) }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('delivery_management.distributed_quantity_pcs') }} </td>
                                    <td>: {{ $n(formData.total_distributed_quantity, { useGrouping: false }) }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('assitive_device_management.idsc_center') }}</td>
                                    <td>: {{ i18n === 'bn' ? formData.center_name_bn : formData.center_name_en }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('grant_registration.application_type') }}</td>
                                    <td>: <span class="badge badge-default bg-dark">{{ i18n === 'bn' ? formData.application_type_bn : formData.application_type_en }}</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('assitive_device_management.distributed_device_list') }}</u></p>
                    <b-table-simple striped bordered small>
                        <b-tr>
                            <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                            <b-th>{{ $t('assitive_device_management.device_name') }}</b-th>
                            <b-th>{{ $t('assitive_device_management.requested_quantity') }}</b-th>
                            <b-th>{{ $t('assitive_device_management.approved_quantity') }}</b-th>
                            <b-th>{{ $t('assitive_device_management.distributed_quantity') }}</b-th>
                            <b-th>{{ $t('assitive_device_management.rest_quantity') }}</b-th>
                            <b-th>{{ $t('globalTrans.remarks') }}</b-th>
                        </b-tr>
                        <b-tr v-for="(item, index) in formData.details" :key="index">
                            <b-td>{{ $n(index + 1) }}</b-td>
                            <b-td>{{ deviceNameById(item.assistive_device_id) }}</b-td>
                            <b-td>{{ $n(item.no_of_quantity) }}</b-td>
                            <b-td>{{ $n(item.approved_quantity) }}</b-td>
                            <b-td>{{ $n(item.distributed_quantity) }}</b-td>
                            <b-td>{{ $n(item.rest_quantity) }}</b-td>
                            <b-td>{{ item.remarks }}</b-td>
                        </b-tr>
                        <!-- <b-tr>
                            <b-td colspan="2">
                                <span style="text-align: right; font-weight: bold;">{{ $t('sales_center.grand_total') }}</span>
                            </b-td>
                            <td>666</td>
                            <td>666</td>
                            <td>666</td>
                            <td>666</td>
                            <td>666</td>
                        </b-tr> -->
                    </b-table-simple>
                    <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('assitive_device_management.patient_organization_representative_details') }}</u></p>
                    <table  class="table table-bordered table-sm" width="50%">
                        <tr>
                            <td width="25%">
                                {{ $t('globalTrans.name') }}
                            </td>
                            <td>: {{ i18n === 'bn' ? formData.name_bn : formData.name_en }}</td>
                        </tr>
                        <tr v-if="formData.application.application_type === 1">
                            <td width="25%">
                                {{$t('retailerManagement.father_name')}}
                            </td>
                            <td>: {{ i18n === 'bn' ? formData.father_name_bn : formData.father_name_en }}</td>
                        </tr>
                        <tr v-if="formData.application.application_type === 1">
                            <td width="25%">
                                {{$t('retailerManagement.mother_name')}}
                            </td>
                            <td>: {{ i18n === 'bn' ? formData.mother_name_bn : formData.mother_name_en }}</td>
                        </tr>
                        <tr v-if="formData.application.application_type === 1">
                            <td width="25%">
                                {{$t('info_manage.birth_date')}}
                            </td>
                            <td>: {{ formData.birth_date | dateFormat }}</td>
                        </tr>
                        <tr v-if="formData.application.application_type > 1">
                            <td width="25%">
                                {{ $t('globalTrans.designation') }}
                            </td>
                            <td>: {{ i18n === 'bn' ? formData.application.designation_bn : formData.application.designation_en }}</td>
                        </tr>
                        <tr v-if="formData.application.application_type > 1">
                            <td width="25%">
                                {{ $t('globalTrans.organization') }}
                            </td>
                            <td>: {{ i18n === 'bn' ? formData.application.organization_name_bn : formData.application.organization_name_en }}</td>
                        </tr>
                        <tr>
                            <td>
                                {{$t('sales_distribution_admin.contact_no')}}
                            </td>
                            <td>: {{ $n(formData.application.contact_no, { useGrouping: false }) }}</td>
                        </tr>
                        <tr>
                            <td>
                                {{$t('retailerManagement.email')}}
                            </td>
                            <td>: {{ formData.application.email }}</td>
                        </tr>
                        <tr v-if="formData.application.application_type === 1">
                            <td>
                                {{$t('retailerManagement.nid')}}
                            </td>
                            <td>: {{ $n(formData.nid, { useGrouping: false }) }}</td>
                        </tr>
                    </table>
                    <!-- <div v-if="formData" class="col-md-12 p-0 m-0 pb-4">
                        <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('committee.document') }} : </u></p>
                        <b-img style='height:300px; width:80%' fluid :src="baseUrl + 'download-attachment?file=' + formData.application.attachment"  alt="Right image"></b-img>
                    </div> -->
                </b-col>
                <!-- <div class="col text-right mt-4">
                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.close') }}</b-button>
                </div> -->
            </b-row>
            <b-row>
                <b-col class="mt-5">
                    <span class="badge badge-default text-dark">{{$t('delivery_management.received_by')}} ----------------------------</span>
                </b-col>
            </b-row>
        </b-col>
        </b-row>
      </b-container>
</template>
<style>
.form-for-textarea textarea{ line-height: 18px !important;height: 54px !important; }
</style>
<script>
import { core } from '@/config/pluginInit'
import { awarenessEventServiceBaseUrl } from '@/config/api_config'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export_pdf'

export default {
  props: ['id'],
  components: {
        ListReportHead
    },
  created () {
    if (this.id) {
      this.getagentData()
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      i18n: this.$i18n.locale,
      formData: [],
      loading: false,
      baseUrl: awarenessEventServiceBaseUrl,
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl
    }
  },
  computed: {
  },
  methods: {
    getDueAmount () {
       return this.formData.delivery_rec_main.total_amount - this.formData.amount
    },
    getagentData () {
        this.loading = true
        this.formData = this.$store.state.list.find(receipt => receipt.id === this.id)
        this.loading = false
    },
    getGrandTotal () {
      const result = this.formData.grand_total_price
      const total = parseFloat(result)
      return total
    },
    deviceNameById (id) {
        const device = this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(device => device.value === id)
        if (typeof device === 'undefined') {
            return ''
        } else {
            if (this.$i18n.locale === 'bn') {
                return device.text_bn
            } else {
                return device.text_en
            }
        }
    },
    getPaymentTypeName (Id) {
        const Obj = this.$store.state.ExternalUser.commonObj.paymentTypeList.find(item => item.value === parseInt(Id))
        if (this.i18n === 'bn'.locale === 'bn') {
            return Obj.text_bn
        } else {
            return Obj.text_en
        }
    },
    getStoreData (state, Id) {
      if (state) {
        const tmpData = this.$store.state.ExternalUser.productionCommonObj[state]
        if (typeof tmpData === 'undefined') {
          return ''
        } else {
          const data = tmpData.find(item => item.value === Id)
          if (typeof data === 'undefined') {
            return ''
          } else {
            return this.i18n === 'bn' ? data.text_bn : data.text_en
          }
        }
      }
    },
    getCommonStoreData (state, Id) {
      if (state) {
        const tmpData = this.$store.state.ProductionService.commonObj[state]
        if (typeof tmpData === 'undefined') {
          return ''
        } else {
          const data = tmpData.find(item => item.value === Id)
          if (typeof data === 'undefined') {
            return ''
          } else {
            return this.i18n === 'bn' ? data.text_bn : data.text_en
          }
        }
      }
    },
    pdfExport () {
      const reportTitle = ''
      ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.formData, this)
    }
  }
}
</script>
